<template>
	<div v-if="value">
		<BaseHeader :title="title" />

		<div class="px-8">
			<div class="flex tr mt-8">
				<div class="md:gap-1 flex-grow items-baseline md:mr-6 md:w-1/2">
					<BaseInput :label="$t('company')" type="text" v-model="value.name" :disabled="true" />

					<BaseInput :label="$t('tax_number')" type="text" v-model="value.taxNumber" :disabled="true" />

					<div class="flex space-x-4">
						<BaseInput class="w-1/2" :label="$t('owner_first_name')" type="text" v-model="value.ownerFirstname" :disabled="true" />
						<BaseInput class="w-1/2" :label="$t('owner_last_name')" type="text" v-model="value.ownerLastname" :disabled="true" />
					</div>

					<div class="flex">
						<BaseInput :label="$t('street')" type="text" v-model="value.street" class="w-full mr-4" :disabled="true" />
						<BaseInput :label="$t('number')" type="text" v-model="value.houseNumber" :disabled="true" />
					</div>

					<CityInput v-model="value.city" :disabled="true" />

					<div class="flex w-full space-x-4">
						<BaseInput class="w-full" :label="$t('phone')" type="tel" v-model="value.phoneNumber" :disabled="true" />
						<BaseInput class="w-full" :label="$t('mobile_number')" type="tel" v-model="value.mobileNumber" :disabled="true" />
					</div>

					<BaseInput :label="$t('fax')" type="text" v-model="value.fax" :disabled="true" />

					<BaseInput :label="$t('first_e_mail_address')" type="email" v-model="value.email" :disabled="true" />

				</div>

				<div class="md:gap-1 flex-grow items-baseline md:w-1/2">
					<BaseInput :label="$t('name_of_bank')" type="text" v-model="value.bankAccount.bank" :disabled="true" />

					<BaseInput :label="$t('iban')" type="text" v-model="value.bankAccount.iban" :disabled="true" />

					<BaseInput :label="$t('bic')" type="text" v-model="value.bankAccount.bic" :disabled="true" />
				</div>
			</div>
		</div>

		<div class="px-8 pb-8 pt-6">
			<slot name="buttons" />
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import BaseInput from '@/components/forms/inputs/BaseInput';
import CityInput from '@/components/forms/CityInput';
import BaseSelect from '@/components/forms/inputs/BaseSelect';

export default {
	name: 'PremiumLawyerOfficeProfileForm',
	components: {
		BaseHeader,
		BaseInput,
		CityInput,
		BaseSelect,
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		companyType: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			hrOptions: [
				{ display: 'HRB', value: 'hrb' },
				{ display: 'HRA', value: 'hra' },
			],
		};
	},
	computed: {
		title() {
			return `Premium ${this.companyType}`;
		},
		selectedHrOption: {
			get() {
				if (!this.value?.hr) {
					return null;
				}

				return this.hrOptions.find(option => option.value === this.value.hr) || null;
			},
			set() {},
		},
	},
};
</script>
